module.exports = __webpack_public_path__ + "img/strategy_contract.aa6b22ba.svg";